// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cdqt","col":"styles_col__2XfKx"};